import { useCallback } from 'react'
import { EVENT_INSTANCE_TYPES } from 'settings/constants/service'
import { isDailyRecurrence, isWeeklyRecurrence } from 'utils/service'
import { findRecurrenceOptionByKey } from 'components/configured-service/EditServiceRecurrenceDialog/utils/recurrenceOptionsHelper'

export const useCreateDraftValidation = ({ methods, recurrenceOptions, isScheduleTab, isNonOnRequestService }) => {
  const validateNonWeeklyFields = useCallback(() => {
    if (!isScheduleTab || !isNonOnRequestService) return true

    const currentInterval = methods.getValues('serviceInterval')
    const currentFreq = methods.getValues('recurrenceFrequency')
    const currentInstanceType = methods.getValues('eventInstanceType')
    const currentOcc = methods.getValues('eventOccurrence')
    const currentDow = methods.getValues('dayOfTheWeek')
    const currentDom = methods.getValues('dayOfTheMonth')

    let interval = null
    const selectedOption = findRecurrenceOptionByKey(recurrenceOptions, currentInterval)

    if (selectedOption) {
      interval = selectedOption.recurrenceInterval
    }

    if (!interval) return true

    // Skip if Weekly or Daily
    if (isWeeklyRecurrence(interval) || isDailyRecurrence(interval)) return true

    // Must have instance type for non-weekly/non-daily
    if (!currentInstanceType) return false

    const count = parseInt(currentFreq, 10) || 1

    if (currentInstanceType === EVENT_INSTANCE_TYPES.DAY_OF_WEEK) {
      const occList = Array.isArray(currentOcc) ? currentOcc : [currentOcc]
      const dowList = Array.isArray(currentDow) ? currentDow : [currentDow]

      const occFilled = occList.filter(v => v !== undefined && v !== null && v !== '').length === count
      const dowFilled = dowList.filter(v => v !== undefined && v !== null && v !== '').length === count

      return occFilled && dowFilled
    }

    if (currentInstanceType === EVENT_INSTANCE_TYPES.SPECIFIC_DATE) {
      const domList = Array.isArray(currentDom) ? currentDom : [currentDom]
      return domList.filter(v => v !== undefined && v !== null && v !== '').length === count
    }

    return true
  }, [isScheduleTab, isNonOnRequestService, methods, recurrenceOptions])

  return { validateNonWeeklyFields }
}
